import React, { useEffect } from "react";
import { isBool } from "../../../../../util/helper";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../app/reducer";
import { setPaymentState } from "../../../../../slices/store";
import { renderTop, renderHalfTxtInput } from "./payment-functions";
import { getPreviouslySetCredentialCode, getPreviouslySetMerchantCode } from "../helper";
import config from "config";

function App(): JSX.Element {
    const dispatch = useDispatch();
    const setState = (name: string, value: any) => dispatch(setPaymentState({ name, value }));
    const switchChange = (name: string, value: any) => dispatch(setPaymentState({ name, value: isBool(!value) }));
    const paymentOptions = useSelector((state: RootState) => state.store?.storePaymentOptions);
    const { wechat_app_id, wechat_credential, wechat_merch_id, wechat_enabled } = paymentOptions;

    useEffect(() => {
        copyDataOfCertainBlankFields();
    }, []);

    useEffect(() => {
        copyDataOfCertainBlankFields();
    }, [wechat_enabled]);

    const copyDataOfCertainBlankFields = () => {
        if (!wechat_enabled) {
            return;
        }

        if (!wechat_merch_id) {
            setState("wechat_merch_id", getPreviouslySetMerchantCode(paymentOptions));
        }
        if (!wechat_credential) {
            setState("wechat_credential", getPreviouslySetCredentialCode(paymentOptions));
        }
        if (!wechat_app_id) {
            setState("wechat_app_id", config.WECHAT_APP_ID);
        }
    };

    return (
        <div className="white-single-block d-flex flex-column justify-content-start align-items-start">
            {renderTop("wechat_account_setting", "wechat_account_desc", "wechat_enabled", wechat_enabled, switchChange)}
            {wechat_enabled ? (
                <div className="payment-input-container">
                    {renderHalfTxtInput("merchant_id", "wechat_merch_id", wechat_merch_id, setState, false, true)}
                    {renderHalfTxtInput("credential", "wechat_credential", wechat_credential, setState, false, true)}
                    {renderHalfTxtInput("app_id", "wechat_app_id", wechat_app_id, setState, true, true)}
                </div>
            ) : null}
        </div>
    );
}

export default App;
